/*eslint no-undef: 0*/

export const toggleActionTypes = {
  TOGGLE_MENU: 'TOGGLE/TOGGLE_MENU'
};

export const toggleMenu = show => ({
  type: toggleActionTypes.TOGGLE_MENU,
  show
});



/** WEBPACK FOOTER **
 ** ./src/state/toggle/actions.js
 **/